import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { DialogTitle, DialogContent, DialogActions, Grid } from "@mui/material";
import { StyledDialog } from "../../../../common/components/Dialog";
import { StyledButton } from "../../../../common/components/Button";
import { StyledTextField } from "../../../../common/components/TextField/styles";
import { yupResolver } from "@hookform/resolvers/yup";
import { updateAlignerMaterial } from "../../../../api/alignerMaterialsApi";
import { alignerMaterialSchema } from "../../schemas/alignerMaterialSchema";
const UpdateAlignerMaterialDialog = ({
  openUpdateAlignerMaterial,
  handleCloseUpdateAlignerMaterial,
  currentAlignerMaterial,
  fetchAlignerMaterials,
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    reset,
  } = useForm({
    resolver: yupResolver(alignerMaterialSchema),
    defaultValues: {
      id: "",
      name: "",
      email: "",
      price: 0,
    },
  });

  useEffect(() => {
    let defaultValues = {};
    defaultValues.id = currentAlignerMaterial.id;
    defaultValues.serviceId = currentAlignerMaterial.serviceId;
    defaultValues.name = currentAlignerMaterial.name;
    defaultValues.email = currentAlignerMaterial.email;
    defaultValues.price = currentAlignerMaterial.price;
    reset({ ...defaultValues });
  }, [currentAlignerMaterial, reset]);

  const submitUpdateAlignerMaterial = async (values) => {
    await updateAlignerMaterial(values);
    handleCloseUpdateAlignerMaterial();
    fetchAlignerMaterials();
  };

  return (
    <div>
      <StyledDialog
        open={openUpdateAlignerMaterial}
        onClose={handleCloseUpdateAlignerMaterial}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle> Update Aligner Material</DialogTitle>
        <form onSubmit={handleSubmit(submitUpdateAlignerMaterial)}>
          <DialogContent dividers>
            <Grid container direction="row">
              <Grid item xs={10}>
                <StyledTextField
                  variant="outlined"
                  label="Aligner Material"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  error={errors.name}
                  helperText={errors.name?.message}
                  {...register("name")}
                  sx={{ width: "100%" }}
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <StyledButton
              theme="purple"
              type="button"
              onClick={handleCloseUpdateAlignerMaterial}
            >
              Cancel
            </StyledButton>
            <StyledButton theme="green" type="submit" disabled={isSubmitting}>
              Submit
            </StyledButton>
          </DialogActions>
        </form>
      </StyledDialog>
    </div>
  );
};

export default UpdateAlignerMaterialDialog;
